var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquarePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.302 9.16795C10.9951 8.96338 10.6006 8.94431 10.2754 9.11833C9.95031 9.29235 9.74731 9.63121 9.74731 10V14C9.74731 14.3688 9.95031 14.7077 10.2754 14.8817C10.6006 15.0557 10.9951 15.0366 11.302 14.8321L14.302 12.8321C14.5802 12.6466 14.7473 12.3344 14.7473 12C14.7473 11.6656 14.5802 11.3534 14.302 11.168L11.302 9.16795Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24731 18C2.24731 20.2091 4.03817 22 6.24731 22H18.2473C20.4564 22 22.2473 20.2091 22.2473 18V5.99999C22.2473 3.79086 20.4564 2 18.2473 2H6.24731C4.03817 2 2.24731 3.79086 2.24731 6V18ZM20.2473 18C20.2473 19.1046 19.3519 20 18.2473 20H10.2973V19.9982H8.1973V20H6.24731C5.14274 20 4.24731 19.1046 4.24731 18V10.05H4.26038V7.94998H4.24731V6C4.24731 4.89543 5.14274 4 6.24731 4H18.2473C19.3519 4 20.2473 4.89543 20.2473 6V7.94998H20.2344V10.05H20.2473V18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePlay);
export default __webpack_public_path__ + "static/media/square_play.6484d8ee8861f50f14319b41acc8a892.svg";
export { ForwardRef as ReactComponent };